import ChannelAttributesToolbar from "./ChannelAttributesToolbar";

export default ChannelAttributesToolbar;
